export default __webpack_public_path__ + "static/media/icon-home.a239902a.svg";